import { ShiftDetailView } from '@/domains/shifts/components/ShiftDetailView';
import {
  useAssignShift,
  useAssignShiftToTeam,
  useDeleteAssignment,
  useShift,
  useUpdateShift,
} from '@/domains/shifts/hooks/useShifts';
import { useNavigate, useParams } from 'react-router';

export function ShiftDetailPage() {
  const { shiftId } = useParams<{ shiftId: string }>();
  const navigate = useNavigate();

  const id = shiftId ? Number(shiftId) : null;
  const { data: shift, isLoading } = useShift(id);
  const updateShift = useUpdateShift(id ?? 0);
  const assignShift = useAssignShift();
  const assignShiftToTeam = useAssignShiftToTeam();
  const deleteAssignment = useDeleteAssignment();

  if (!shiftId) return null;

  return (
    <ShiftDetailView
      shift={shift ?? null}
      isLoading={isLoading}
      onBack={() => navigate('/shifts')}
      onUpdateShift={async (data) => {
        await updateShift.mutateAsync(data);
      }}
      onAssignShift={async (data) => {
        await assignShift.mutateAsync(data);
      }}
      onAssignShiftToTeam={async (data) => {
        await assignShiftToTeam.mutateAsync(data);
      }}
      onDeleteAssignment={async (id) => {
        await deleteAssignment.mutateAsync(id);
      }}
    />
  );
}
